export const conversationFooterHeight = ({ conversationFooterHeight }) =>
  conversationFooterHeight

export const headerHeight = ({ headerHeight }) => headerHeight

export const overlayOpen = ({ overlayOpen }) => overlayOpen

export const parentSize = ({ parentSize }) => parentSize
